/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProfileHeaderBreadcrumbs_tradeFirm = {
    readonly name: string | null;
    readonly " $refType": "ProfileHeaderBreadcrumbs_tradeFirm";
};
export type ProfileHeaderBreadcrumbs_tradeFirm$data = ProfileHeaderBreadcrumbs_tradeFirm;
export type ProfileHeaderBreadcrumbs_tradeFirm$key = {
    readonly " $data"?: ProfileHeaderBreadcrumbs_tradeFirm$data;
    readonly " $fragmentRefs": FragmentRefs<"ProfileHeaderBreadcrumbs_tradeFirm">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileHeaderBreadcrumbs_tradeFirm",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "TradeFirmType",
  "abstractKey": null
};
(node as any).hash = '748bb967227fc1a338ffaace8c071d34';
export default node;
